import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../global/globals';
import { AgreementQualityOverview } from '../dtos/agreement-quality-overview';

@Injectable({
  providedIn: 'root',
})
export class AgreementQualityOverviewService {
  private baseUri = this.globals.backendUri + '/projects';

  constructor(
    private httpClient: HttpClient,
    private globals: Globals,
  ) {}

  getOverview(projectId: string): Observable<AgreementQualityOverview> {
    return this.httpClient.get<AgreementQualityOverview>(
      `${this.baseUri}/${projectId}/statistics/agreement-overview`,
    );
  }
}
